import React from 'react'
import { useLocation } from 'react-router-dom'

import Logo from '@components/Icons/Logo'

import styles from './styles.module.css'

const Header = ({ children }) => {
  const { pathname } = useLocation()

  return (
    <header className={styles.header} data-url={pathname}>
      <div className={styles.brand}>
        <Logo width={30} />
        <div className={styles.headers}>
          <h1>Media Search</h1>
          <h2>Compassion Community</h2>
        </div>
      </div>
      {children}
    </header>
  )
}

export default Header
